<template>
  <div class="companies">
    <section class="section-header">
      <h1>
        <Link to="/admin/users">Admin</Link>
        <Link to="/admin/users">{{ $t('meta.users') }}</Link>
        {{ $t('companies.addUser') }}
      </h1>
      <div class="meta">
        <Link to="/admin/users" class="button button-grey button-round button-small">{{
          $t('companies.allUsers')
        }}</Link>
      </div>
    </section>

    <div class="body-content cf">
      <div class="entries-wrap">
        <admin-nav></admin-nav>
        <div class="body">
          <UserBaseData :templateMode="'add'" :user="user" :onSubmitBaseData="createUser" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserBaseData from '@/components/UserBaseData'
import AdminNav from '@/components/admin_nav'

import adminsApi from '@/api/admin'

export default {
  name: 'admin_user',
  components: {
    AdminNav,
    UserBaseData,
  },
  data() {
    return {
      loading: true,
      user: {},
    }
  },
  methods: {
    createUser: async function (userData) {
      const newUser = await adminsApi.createUser(userData)
      if (newUser) {
        await this.$router.push(`/admin/users/${newUser.uuid}`)
      }
    },
  },
}
</script>
